import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  name: "",
  selectedEmails: [],
  showPerPage: {
    outgoing: null,
    processed: null,
    "unprocessed-dashboard": null,
    "unprocessed-overview": null,
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
